import { render, staticRenderFns } from "./AnnotationPanel.vue?vue&type=template&id=659d766e&scoped=true"
import script from "./AnnotationPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPanel.vue?vue&type=style&index=0&id=659d766e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d766e",
  null
  
)

export default component.exports